import React from 'react'
import PropTypes from 'prop-types'
import { Link, useLocation } from 'react-router-dom'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Tonality } from '@dsny/dsny-component-library'
import labelPlaceholderLogo from 'images/icons/labelPlaceholder.png'
import {
  LabelSearchCardContainer,
  ImageContainer,
  LabelSearchCardImage,
  TextContainer
} from './LabelSearchCard.styles'

export default function LabelSearchCard({ label }) {
  const theme = useTheme()
  const { t } = useTranslation()
  const location = useLocation()
  const searchBackTo = `${location.pathname}${location.search}${location.hash}`

  return (
    <Link
      state={{ searchBackTo }}
      to={`/search/releases/label?q=${encodeURIComponent(label.label)}`}
      style={{ textDecoration: 'none' }}
    >
      <LabelSearchCardContainer>
        <ImageContainer>
          <LabelSearchCardImage
            src={label?.logo || labelPlaceholderLogo}
            alt="label logo"
          />
        </ImageContainer>

        <TextContainer>
          <Tonality.UIText
            textStyle="body"
            style={{
              fontSize: 18,
              fontWeight: 700,
              lineHeight: '20px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
            color={theme.colors.neutralW100}
          >
            {label?.label}
          </Tonality.UIText>
          <Tonality.UIText
            textStyle="body"
            style={{
              fontSize: 14,
              fontWeight: 400,
              lineHeight: '20px',
              marginTop: 4,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
            color={theme.colors.neutralW70}
          >
            {label?.releases} {t('search.releases')}
          </Tonality.UIText>
        </TextContainer>
      </LabelSearchCardContainer>
    </Link>
  )
}

LabelSearchCard.propTypes = {
  label: PropTypes.shape({
    label: PropTypes.string,
    releases: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    logo: PropTypes.string
  }).isRequired
}
